import { createActions, createState, createReducer } from 'reduxsauce-crud'

const DEEP = { deep: true }

export const ValidatedReceiptsRedux = createActions(
  {
    unvalidateRequest: ['id', 'body'],
    unvalidateSuccess: ['data'],
    unvalidateFailure: ['errors'],
    unValidateError: [''],
  },
  {
    prefix: 'VALIDATED_RECEIPTS_',
    defaultActions: {
      get: true,
    },
  },
)

const { Types, Creators } = ValidatedReceiptsRedux
export const ValidatedReceiptsTypes = Types
export default Creators

export const INITIAL_STATE = createState({}, {
  get: true,
})

/** Filter all the received data by validated_at !== null. When the user invalidate a receipt */
export const getValidateReceipts = (data = []) => data.filter(o => o.validated_at !== null)

const unvalidateRequest = state => state.merge({}, DEEP)
const unvalidateSuccess = (state, { data }) => state.merge({ get: { results: { data } } }, DEEP)
const unvalidateFailure = (state, { errors }) => state.merge({ ...errors }, DEEP)
const unValidateError = (state)=> state.merge({ get: { results: [] } }, DEEP)
export const reducer = createReducer(INITIAL_STATE, {
  [Types.unvalidateRequest]: unvalidateRequest,
  [Types.unvalidateSuccess]: unvalidateSuccess,
  [Types.unvalidateFailure]: unvalidateFailure,
  [Types.unValidateError]: unValidateError,
},
{
  defaultActions: {
    get: true,
  },
  Types,
},
)



// WEBPACK FOOTER //
// ./src/Data/Redux/ValidatedReceiptsRedux.js